/**
 * Check if the given parameter is a function
 * @param {*} obj Any object to test
 * @returns {boolean} <tt>true</tt> if the given parameter is a function, <tt>false</tt> otherwise
 */
export const isFunction = obj => (typeof obj) === 'function';

/**
 * Check if the given parameter is an integer
 * @param {*} obj Any object to test
 * @returns {boolean} <tt>true</tt> if the tested object is an integer
 */
export const isInteger = Number.isInteger;

/**
 * Check if the given parameter is an object
 * @param {*} obj Any object to test
 * @returns {boolean} <tt>true</tt> if the tested object is an object and not null
 */
export const isObject = (obj) => {
    if (obj === null ) { return false; }
    if (typeof obj === 'function') { return true; }
    return (typeof obj === 'object');
};